import { render, staticRenderFns } from "./FixedCostRoi.vue?vue&type=template&id=3845938e&"
import script from "./FixedCostRoi.vue?vue&type=script&lang=js&"
export * from "./FixedCostRoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports